module.exports = __webpack_public_path__ + "img/26-challenger.c5704a9f.png";